import React, { Fragment } from 'react'
import { Card, withStyles } from '@material-ui/core'
import { Col, Row } from 'react-bootstrap'
import cn from 'classnames'
import { SectionTitle } from '../../../Components/Section'
import { openLinkInNewTab } from '../../Country/Page/Pipeline/PipelineView/utils'
import { PATHS } from '../../../Config/Routing/paths'
import UsersEdit from './UsersEdit'
import SubmitButton from '../../../Components/Form/Button'
import { Input } from 'Components/Form/Input'
import { required, email } from 'Utils/Validators/formValidation'
import { SelectDashboard } from '../../../Components/Form'
import { styles } from './styles'
import XeroConnected from '../../../Components/XeroConnected'

const XeroClient = ({
  classes,
  isXeroAvailable,
  xeroInfo,
  tenant,
  xeroInitValues,
  currencies,
  usersHashMap,
  addUser = () => {},
  onUserDelete = () => {},
  onUserChange = () => {},
  isEditMode,
}) => {
  return isXeroAvailable ? (
    <Card className={classes.card}>
      <Fragment>
        <Row xs={12}>
          <SectionTitle
            className={cn('section-title-inline', classes.xeroTitle)}
          >
            <div>Xero</div>
            {!tenant ? (
              <SubmitButton
                variant="contained"
                value="Go to Xero settings"
                onClick={() => {
                  openLinkInNewTab(
                    `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.xeroConnection
                    }`,
                  )
                }}
              />
            ) : null}
          </SectionTitle>
          {!xeroInfo.isLoading ? (
            <div className={classes.xeroStatusWrapper}>
              <Col xs={3}>
                <XeroConnected isConnected={xeroInfo.entity} />
              </Col>
              {xeroInfo.entity ? (
                <Fragment>
                  <Col xs={3}>Entity: {xeroInfo.entity}</Col>
                  {xeroInfo.error ? (
                    <Col xs={3}>Error: {xeroInfo.error}</Col>
                  ) : (
                    <Fragment>
                      <Col xs={3}>
                        Contact: {xeroInfo.contact || 'Not found'}
                      </Col>
                      {!xeroInfo.contact && xeroInfo.closestContact ? (
                        <Col xs={3}>
                          Closest contact: {xeroInfo.closestContact || '-'}
                        </Col>
                      ) : null}
                    </Fragment>
                  )}
                </Fragment>
              ) : null}
            </div>
          ) : (
            'Loading'
          )}
        </Row>
        {tenant ? (
          <Fragment>
            <Row xs={12} className={cn(classes.row, classes.mt20)}>
              <Col xs={6}>
                <Input
                  label="Company legal name (Contact name)"
                  name="xeroLegalName"
                  placeholder="Company legal name"
                  validator={[required]}
                  initValue={
                    !xeroInfo.isLoading && xeroInfo.entity
                      ? xeroInfo.contact
                      : ''
                  }
                  disabled={!isEditMode}
                />
              </Col>
            </Row>
            <Row xs={12} className={classes.row}>
              <Col xs={3}>
                <Input
                  label="First Name"
                  name="xeroFirstName"
                  placeholder="Jon"
                  validator={[required]}
                  initValue={xeroInitValues.firstName}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Last Name"
                  name="xeroLastName"
                  placeholder="Dou"
                  validator={[required]}
                  initValue={xeroInitValues.lastName}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Email"
                  name="xeroEmailAddress"
                  placeholder=""
                  validator={[required, email]}
                  initValue={xeroInitValues.emailAddress}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <SelectDashboard
                  className={classes.input}
                  name="xeroDefaultCurrency"
                  label="Currency"
                  options={currencies}
                  value={xeroInitValues.defaultCurrency}
                  validator={[required]}
                  disabled={!isEditMode}
                />
              </Col>
            </Row>
            {!isEditMode && !Object.keys(usersHashMap).length ? null : (
              <Row xs={12}>
                <Col xs={12} className={classes.mb20}>
                  <SectionTitle
                    className={cn('section-title-inline', classes.xeroTitle)}
                  >
                    Contact Persons
                  </SectionTitle>
                  <UsersEdit
                    usersHashMap={usersHashMap}
                    addUser={addUser}
                    onUserChange={onUserChange}
                    onUserDelete={onUserDelete}
                    isEditMode={isEditMode}
                  />
                </Col>
              </Row>
            )}
            <Row
              xs={12}
              className={
                !isEditMode && !Object.keys(usersHashMap).length
                  ? classes.mb20
                  : classes.mb30
              }
            >
              <Col xs={3}>
                <Input
                  label="Address 1"
                  name="xeroAddress1"
                  placeholder=""
                  initValue={xeroInitValues.address1}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Address 2"
                  name="xeroAddress2"
                  placeholder=""
                  initValue={xeroInitValues.address2}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Address 3"
                  name="xeroAddress3"
                  placeholder=""
                  initValue={xeroInitValues.address3}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Address 4"
                  name="xeroAddress4"
                  placeholder=""
                  initValue={xeroInitValues.address4}
                  disabled={!isEditMode}
                />
              </Col>
            </Row>
            <Row xs={12} className={cn(classes.mb20, classes.row)}>
              <Col xs={3}>
                <Input
                  label="City"
                  name="xeroCity"
                  placeholder=""
                  initValue={xeroInitValues.city}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Region"
                  name="xeroRegion"
                  placeholder=""
                  initValue={xeroInitValues.region}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Postal Code"
                  name="xeroPostalCode"
                  placeholder=""
                  initValue={xeroInitValues.postalCode}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                {xeroInitValues.country ? (
                  <Input
                    label="Xero Country"
                    name="xeroCountry"
                    placeholder=""
                    disabled={true}
                    initValue={xeroInitValues.country}
                  />
                ) : null}
              </Col>
            </Row>
            <Row xs={12} className={classes.mb20}>
              <Col xs={3}>
                <Input
                  label="Attention To"
                  name="xeroAttentionTo"
                  placeholder=""
                  initValue={xeroInitValues.attentionTo}
                  disabled={!isEditMode}
                />
              </Col>
              <Col xs={3}>
                <Input
                  label="Sales Default Account Code"
                  name="xeroSalesDefaultAccountCode"
                  disabled={true}
                  placeholder=""
                  initValue={xeroInitValues.salesDefaultAccountCode}
                />
              </Col>
              {xeroInitValues.trackingCategoryName ? (
                <Col xs={3}>
                  <Input
                    label="Sales Tracking Categories"
                    name="xeroTrackingCategoryName"
                    placeholder=""
                    disabled={true}
                    initValue={xeroInitValues.trackingCategoryName}
                  />
                </Col>
              ) : null}
              <Col xs={3}>
                <Input
                  label="Sales Default Line Amount Type"
                  name="xeroSalesDefaultLineAmountType"
                  placeholder=""
                  disabled={true}
                  initValue={xeroInitValues.salesDefaultLineAmountType}
                />
              </Col>
            </Row>
          </Fragment>
        ) : null}
      </Fragment>
    </Card>
  ) : (
    <div />
  )
}

export default withStyles(styles)(XeroClient)
